import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

const CRMMenu = () => {
    const navigate = useNavigate();
    const menu = [
        {
            name: "Calendar",
            route: "/calender",
            icon: "bi bi-calendar",
            url: "assets/images/menu/calendar.png",
        },
        {
            name: "Customers",
            route: "/Customers_list",
            icon: "bi bi-person-lines-fill",
            url: "assets/images/menu/customer.png",
        },
        {
            name: "Client Feedback",
            route: "/Client_feedback",
            icon: "bi bi-people",
            url: "assets/images/menu/user.png",
        },
    ];

    const handleCardClick = (route) => {
        navigate(route);
    };

    return (
        <div className="my-4 mx-3 pb-5">
            <div className="product-grid row justify-content-center" style={{ padding: "10 25px" }}>
                {menu?.map((entity, index) => (
                    <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2" key={index}>
                        <div
                            className="card h-100 text-center"
                            onClick={() => handleCardClick(entity.route)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="card-body">
                                <img
                                    src={entity?.url}
                                    width={"50px"}
                                    style={{ marginTop: "8px" }}
                                    alt={entity.name}
                                />
                                <h5 className="card-title mt-3 text-small">{entity.name}</h5>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CRMMenu